import type { RedoMerchantLoyaltyRpcClient } from "@redotech/redo-merchant-loyalty-rpc/client";
import { createRedoMerchantLoyaltyRpcClient } from "@redotech/redo-merchant-loyalty-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantLoyaltyRpcClientContext: Context<
  RedoMerchantLoyaltyRpcClient | undefined
> = createContext<RedoMerchantLoyaltyRpcClient | undefined>(undefined);
RedoMerchantLoyaltyRpcClientContext.displayName =
  "RedoMerchantLoyaltyRpcClientContext";

export function RedoMerchantLoyaltyRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantLoyaltyRpcClient({
      baseURL: new URL(`${baseUrl}/loyalty-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantLoyaltyRpcClientContext.Provider value={client}>
      {children}
    </RedoMerchantLoyaltyRpcClientContext.Provider>
  );
}
